import {
  type CipherText,
  type FulfillRequest,
  Payment,
  Product,
} from "@b2bportal/purchase-api";
import {
  CartFulfillState,
  cartQuoteSelectors,
  getChildState,
  ParentState,
} from "@hopper-b2b/checkout";
import type { State } from "xstate";
import { getPaymentSessionToken } from "../../selectors";
import type { FlightMachineContext } from "../../types";

type CartFulfillStateType = State<FlightMachineContext>;
type CartFulfillStateWithoutValue = Pick<CartFulfillStateType, "context">;

export const getFullFillRequestParams = (
  state: CartFulfillStateWithoutValue
): FulfillRequest => {
  const quoteCipherToken = cartQuoteSelectors.getPriceQuoteCipherText(state);

  const selectedPaymentMethodId = getPaymentSessionToken(state);

  // Only Uber Payment allowed
  const payments = [
    {
      type: Payment.UberPayment,
      value: {
        encryptedQuoteToken: quoteCipherToken?.value,
        paymentSessionToken: selectedPaymentMethodId,
      },
    },
  ];

  return {
    quoteToken: quoteCipherToken as CipherText,
    payments,
  };
};

export const getFulfillCipherText = (state: CartFulfillStateWithoutValue) =>
  state.context[ParentState.cartFulfill].fulfillCipherText;

export const getOpenCartFulfillModal = (state: CartFulfillStateType) =>
  [CartFulfillState.polling, CartFulfillState.schedule].includes(
    getChildState(state.value) as CartFulfillState
  );

export const getOpenCartFulfillErrorModal = (state: CartFulfillStateType) =>
  getChildState(state.value) === CartFulfillState.error;

export const getCartFulfillError = (state: CartFulfillStateType) =>
  state.context[ParentState.cartFulfill].error;

//TODO: This selector should be moved to the product state machines when updating Flights checkout to use new cart machines.
export const hasFulfilledAirCfarProduct = (
  state: CartFulfillStateWithoutValue
): boolean => {
  const products = state.context[ParentState.cartFulfill].fulfilledProducts;
  return !!products?.find((p) => p.type === Product.AirCfar);
};

export const hasFulfilledDisruptionProduct = (
  state: CartFulfillStateWithoutValue
): boolean => {
  const products = state.context[ParentState.cartFulfill].fulfilledProducts;
  return !!products?.find((p) => p.type === Product.AirDisruption);
};

export const hasFulfilledAirChfarProduct = (
  state: CartFulfillStateWithoutValue
): boolean => {
  const products = state.context[ParentState.cartFulfill].fulfilledProducts;
  return !!products?.find((p) => p.type === Product.AirChfar);
};
